// extracted by mini-css-extract-plugin
module.exports = {"close-label":"shippable-only_close-label__PXfSC"};